import Api from "../../../../util/Api";

export default function getInitState() {
    return {
        felirtReceptAdditionalConfig: {
            initOnRender: true
        },
        felirtReceptTableActions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModalFelirt'
            }
        ],
        felirtReceptTableRowActions: [
            {
                btn_text: '<i class="far fa-folder"></i>',
                title: 'Megtekintés',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'showPrescriptionDetailsModal',
            },
            {
                btn_text: '<i class="far fa-file-alt"></i>',
                title: 'Felírási igazolás nyomtatása',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'printCertificate',
                additionalButtonVisible: "needPrintPrescriptionCertificate"
            },
            {
                btn_text: '<i class="fas fa-file-prescription"></i>',
                title: 'Vény nyomtatása',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'printPrescription',
                additionalButtonDisable: "canPrintPrescription"
            },
            {
                btn_text: '<i class="fas fa-trash-alt"></i>',
                title: 'Vény visszavonása',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteConfirmPrescription',
                additionalButtonVisible: 'deletePrintVisible'
            }
        ],
        felirtReceptTableSearchFields: [
            {
                name: "paciensIdType",
                label: "Páciens azonosítás típus",
                formSize: 4,
                formType: "select",
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getIdTypeList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "paciensId",
                label: "Páciens azonosító",
                formSize: 4,
                formVisible: true,
                formType: "text"
            },
            {
                name: "idoszakKezdete",
                label: "Időszak kezdete",
                description: "Alapértelmezetten aktuális nap",
                formSize: 4,
                formVisible: true,
                formType: 'date',
            },
            {
                name: "idoszakHossza",
                label: "Időszak hossza",
                description: "Alapértelmezetten 1 hónap, maximum 12 hónap",
                formSize: 4,
                formVisible: true,
                formType: 'number',
            },
            {
                name: "aktivReceptek",
                label: "Aktív receptek?",
                formSize: 4,
                formVisible: true,
                formType: 'checkbox'
            },
            {
                name: "surgos",
                label: "Sürgősségi adatlekérés",
                description: "Sürgős lekérdezés esetén indoklás szükséges!",
                formSize: 4,
                formVisible: true,
                formType: 'checkbox'
            },
            {
                label: "Sürgősségi adatlekérés oka",
                name: "surgosOk",
                formSize: 4,
                formVisible: true,
                formType: 'text'
            }
        ],
        felirtReceptTableHeaderFields: [
            {
                label: "Termék",
                name: "termekNev",
                filter: {
                    type: "simple",
                },
                sort: true
            },
            {
                label: "Kiállítás dátuma",
                name: "venyKiallitasDatuma",
                filter: {
                    type: "simple",
                },
                sort: true
            },
            {
                label: "Érvényesség kezdete",
                name: "ervenyessegKezdete",
                filter: {
                    type: "simple",
                },
                sort: true
            },
            {
                label: "Érvényesség vége",
                name: "ervenyessegVege",
                filter: {
                    type: "simple",
                },
                sort: true
            },
            {
                label: "Kiszerelés",
                name: "kiszereles"
            },
            {
                label: "Státusz",
                name: "receptStatusText",
                filter: {
                    type: "simple",
                },
                sort: true
            },
            {
                label: "Felirt mennyiség",
                name: "felirtMennyiseg",
                sort: true
            },
            {
                label: "Adagolás egység gyakoriság szerint",
                name: "adagolasEgysegGyakorisagSzerint",
                visibility: false
            },
            {
                label: "Adagolás gyakoriság",
                name: "adagolasGyakorisag",
                visibility: false
            },
            {
                label: "Adagolás gyakorisági egység",
                name: "adagolasGyakorisagiEgyseg",
                visibility: false
            },
            {
                label: "Adagolás ismétlődése",
                name: "adagolasIsmetlodese",
                visibility: false
            },
            {
                label: "Adagolás mennyiség gyakoriság szerint",
                name: "adagolasMennyisegGyakorisagSzerint",
                visibility: false
            },
            {
                label: "Adagolás szövegesen",
                name: "adagolasSzovegesen",
                visibility: false
            },
            {
                label: "Adagolás típus",
                name: "adagolasTipus",
                visibility: false
            },
            {
                label: "Adagolási egység",
                name: "adagolasiEgyseg",
                visibility: false
            },
            {
                label: "Adagolási mennyiség D",
                name: "adagolasiMennyisegD",
                visibility: false
            },
            {
                label: "Adagolási mennyiség E",
                name: "adagolasiMennyisegE",
                visibility: false
            },
            {
                label: "Adagolási mennyiség LE",
                name: "adagolasiMennyisegLE",
                visibility: false
            },
            {
                label: "Adagolási mennyiség R",
                name: "adagolasiMennyisegR",
                visibility: false
            },
            {
                label: "Aláírás",
                name: "alairas",
                visibility: false
            },
            {
                label: "Csoport Id",
                name: "csoportId",
                visibility: false
            },
            {
                label: "Diagnózis",
                name: "diagnozis",
                visibility: false
            },
            {
                label: "Dokumentum",
                name: "dokumentum",
                visibility: false
            },
            {
                label: "DokumentumXMLVerzio",
                name: "dokumentumXMLVerzio",
                visibility: false
            },
            {
                label: "Ellátva",
                name: "ellatva",
                visibility: false
            },
            {
                label: "esemenykatalogusId",
                name: "esemenykatalogusId",
                visibility: false
            },
            {
                label: "Felirás jogcime",
                name: "felirasJogcime",
                visibility: false
            },
            {
                label: "Orvos keresztnév",
                name: "feliroOrvosFirstName",
                visibility: false
            },
            {
                label: "Orvos vezetéknév",
                name: "feliroOrvosLastName",
                visibility: false
            },
            {
                label: "Orvosi pecsétszám",
                name: "feliroOrvosPecsetszam",
                visibility: false
            },
            {
                label: "Orvos neve, pecsétszám",
                name: "feliroOrvosTejlesNevPecsetszam",
                visibility: false
            },
            {
                label: "foglalasDatumKezdete",
                name: "foglalasDatumKezdete",
                visibility: false
            },
            {
                label: "foglalasDatumVege",
                name: "foglalasDatumVege",
                visibility: false
            },
            {
                label: "foglalastVegzoGyogyszereszId",
                name: "foglalastVegzoGyogyszereszId",
                visibility: false
            },
            {
                label: "foglalastVegzoGyogyszertarId",
                name: "foglalastVegzoGyogyszertarId",
                visibility: false
            },
            {
                label: "Hatóanyag",
                name: "hatoanyagNev",
                visibility: false
            },
            {
                label: "intezmenyId",
                name: "intezmenyId",
                visibility: false
            },
            {
                label: "Ismétlődő vény",
                name: "ismetlodoVeny",
                visibility: false
            },
            {
                label: "Mennyiség indoklás",
                name: "mennyisegIndoklas",
                visibility: false
            },
            {
                label: "Mennyiségi egység",
                name: "mennyisegiEgyseg",
                visibility: false
            },
            {
                label: "needPrintPrescriptionCertificate",
                name: "needPrintPrescriptionCertificate",
                visibility: false
            },
            {
                label: "paciensId",
                name: "paciensId",
                visibility: false
            },
            {
                label: "paciensTypeId",
                name: "paciensTypeId",
                visibility: false
            },
            {
                label: "patikaiRogzites",
                name: "patikaiRogzites",
                visibility: false
            },
            {
                label: "receptId",
                name: "Recept ID",
                visibility: false
            },
            {
                label: "Recept státusz",
                name: "receptStatusz",
                visibility: false
            },
            {
                label: "receptetRogzitoGyogyszertarId",
                name: "receptetRogzitoGyogyszertarId",
                visibility: false
            },
            {
                label: "sorozatId",
                name: "sorozatId",
                visibility: false
            },
            {
                label: "sorozatIdx",
                name: "sorozatIdx",
                visibility: false
            },
            {
                label: "szervezetiEgysegId",
                name: "szervezetiEgysegId",
                visibility: false
            },
            {
                label: "szolgaltatoId",
                name: "szolgaltatoId",
                visibility: false
            },
            {
                label: "termekId",
                name: "termekId",
                visibility: false
            },
            {
                label: "termekTipus",
                name: "termekTipus",
                visibility: false
            },
            {
                label: "timeOut",
                name: "timeOut",
                visibility: false
            },
            {
                label: "Törlés indoklása",
                name: "torlesIndoklas",
                visibility: false
            },
            {
                label: "Utasítás",
                name: "utasitas",
                visibility: false
            },
            {
                label: "Vény sorszáma",
                name: "venySorszama",
                visibility: false
            },
            {
                label: "Vény típusa",
                name: "venyTipusa",
                visibility: false
            },
            {
                label: "venyirasiKategoria",
                name: "venyirasiKategoria",
                visibility: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],
        felirtReceptDetailsViewModalFields: [
            {
                label: "Felíró orvos neve és pecsétszáma",
                name: "feliroOrvosTejlesNevPecsetszam",
                viewModalShow: true
            },
            {
                label: "Felíró intézmény azonosítója",
                name: "intezmenyId",
                viewModalShow: true
            },
            {
                label: "Felíró szervezeti egység azonosítója",
                name: "szervezetiEgysegId",
                viewModalShow: true
            },
            {
                label: "Recept azonosító",
                name: "receptId",
                viewModalShow: true
            },
            {
                label: "Termék",
                name: "termekNev",
                viewModalShow: true
            },
            {
                label: "Kiszerelés",
                name: "kiszereles",
                viewModalShow: true
            },
            {
                label: "Hatóanyag",
                name: "hatoanyagNev",
                viewModalShow: true
            },
            {
                label: "Recept státusza",
                name: "receptStatusText",
                viewModalShow: true
            },
            {
                label: "Vény kiállításának dátumaa",
                name: "venyKiallitasDatuma",
                viewModalShow: true
            },
            {
                label: "Vény érvényességének kezdete",
                name: "ervenyessegKezdete",
                viewModalShow: true
            },
            {
                label: "Vény érvényességének vége",
                name: "ervenyessegVege",
                viewModalShow: true
            },
            {
                label: "Ismétlődő vény",
                name: "ismetlodoVeny",
                viewModalShow: true,
                formType: "checkbox"
            },
            {
                label: "Diagnózis",
                name: "diagnozis",
                viewModalShow: true
            },
            {
                label: "Orvosi utasítás",
                name: "utasitas",
                viewModalShow: true
            },
            {
                label: "Felirt mennyiség",
                name: "felirtMennyiseg",
                sort: true
            },
            {
                label: "Mennyiségi egység",
                name: "mennyisegiEgyseg",
                viewModalShow: true
            },
            {
                label: "Adagolási mennyiség reggel (napszak szerint)",
                name: "adagolasiMennyisegR",
                viewModalShow: true
            },
            {
                label: "Adagolási mennyiség délben (napszak szerint)",
                name: "adagolasiMennyisegD",
                viewModalShow: true
            },
            {
                label: "Adagolási mennyiség este (napszak szerint)",
                name: "adagolasiMennyisegE",
                viewModalShow: true
            },
            {
                label: "Adagolási mennyiség lefekvés előtt (napszak szerint)",
                name: "adagolasiMennyisegLE",
                viewModalShow: true
            },
            {
                label: "Adagolási egység (napszak szerint)",
                name: "adagolasiEgyseg",
                viewModalShow: true
            },
            {
                label: "Adagolás mennyisége (gyakoriság szerint)",
                name: "adagolasMennyisegGyakorisagSzerint",
                viewModalShow: true
            },
            {
                label: "Adagolás gyakorisági egység (gyakoriság szerint)",
                name: "adagolasGyakorisagiEgyseg",
                viewModalShow: true
            },
            {
                label: "Adagolás gyakorisága (gyakoriság szerint)",
                name: "adagolasGyakorisag",
                viewModalShow: true
            },
            {
                label: "Adagolás egysége (gyakoriság szerint)",
                name: "adagolasEgysegGyakorisagSzerint",
                viewModalShow: true
            },
            {
                label: "Ismétlődés (gyakoriság szerint)",
                name: "adagolasIsmetlodese",
                viewModalShow: true
            },
            {
                label: "Adagolás (szövegesen)",
                name: "adagolasSzovegesen",
                viewModalShow: true
            }
        ],


        kiadottReceptAdditionalConfig: {
            initOnRender: false
        },
        kiadottReceptTableActions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModalKiadott'
            }
        ],
        kiadottReceptTableRowActions: [
            {
                btn_text: '<i class="far fa-folder"></i>',
                title: 'Megtekintés',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'showPublishedPrescriptionDetailsModal',
            }
        ],
        kiadottReceptTableHeaderFields: [
            {
                label: "Kiadott termék",
                name: "termekNev"
            },
            {
                label: "Kiadás dátuma",
                name: "kiadasDatuma"
            },
            {
                label: "Kiadott kiszerelés",
                name: "kiadottKiszereles"
            },
            {
                label: "Kiadott mennyiség",
                name: "kiadottMennyiseg"
            },
            {
                label: "Kiadott mennyiségi egység",
                name: "mennyisegiEgyseg"
            },
            {
                label: "Kiadás jogcíme",
                name: "kiadasJogcime"
            },
            {
                label: "kiadasId",
                name: "kiadasId",
                visibility: false
            },
            {
                label: "receptId",
                name: "receptId",
                visibility: false
            },
            {
                label: "gyogyszertarId",
                name: "gyogyszertarId",
                visibility: false
            },
            {
                label: "kiadoGyogyszereszId",
                name: "kiadoGyogyszereszId",
                visibility: false
            },
            {
                label: "termekTipus",
                name: "termekTipus",
                visibility: false
            },
            {
                label: "termekId",
                name: "termekId",
                visibility: false
            }
        ],
        kiadottReceptDetailsViewModalFields: [
            {
                label: "Termék",
                name: "termekNev",
                viewModalShow: true
            },
            {
                label: "Kiadott kiszerelés",
                name: "kiadottKiszereles",
                viewModalShow: true
            },
            {
                label: "Kiadott mennyiség",
                name: "kiadottMennyiseg",
                viewModalShow: true
            },
            {
                label: "Mennyiségi egység",
                name: "mennyisegiEgyseg",
                viewModalShow: true
            },
            {
                label: "Kiadás dátuma",
                name: "kiadasDatuma",
                viewModalShow: true
            }
        ],

        gyseReceptAdditionalConfig: {
            initOnRender: false
        },
        gyseReceptTableActions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModalGYSE'
            }
        ],
        gyseReceptSearchFields: [
            {
                name: "paciensIdType",
                label: "Páciens azonosítás típus",
                formSize: 4,
                formType: "select",
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getIdTypeList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "paciensId",
                label: "Páciens azonosító",
                formSize: 4,
                formType: "text"
            },
            {
                name: "idoszakKezdete",
                label: "Időszak kezdete",
                formSize: 4,
                formType: 'date',
            },
            {
                name: "idoszakVege",
                label: "Időszak vége",
                formSize: 4,
                formType: 'date',
            },
            {
                name: "aktivReceptek",
                label: "Aktív receptek?",
                formSize: 4,
                formType: 'checkbox'
            },
            {
                name: "surgos",
                label: "Sürgősségi adatlekérés",
                description: "Sürgős lekérdezés esetén indoklás szükséges!",
                formSize: 4,
                formType: 'checkbox'
            },
            {
                label: "Sürgősségi adatlekérés oka",
                name: "surgosOk",
                formSize: 4,
                formType: 'text'
            }
        ],
        gyseReceptTableRowActions: [
            {
                btn_text: '<i class="far fa-file-alt"></i>',
                title: 'Felírási igazolás nyomtatása',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'printGYSECertificate',
                additionalButtonVisible: "deletePrintVisibleGyse"
            },
            {
                btn_text: '<i class="fas fa-trash-alt"></i>',
                title: 'Vény visszavonása',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteGYSEConfirmPrescription',
                additionalButtonVisible: 'deletePrintVisibleGyse'
            }
        ],
        gyseReceptTableHeaderFields: [
            {
                name: "prescriptionId",
                label: "Recept azonosító"
            },
            {
                name: "status",
                label: "Státusz"
            },
            {
                name: "validFrom",
                label: "Érvényesség kezdete"
            },
            {
                name: "validTo",
                label: "Érvényesség vége"
            },
            {
                name: "productName",
                label: "Termék neve"
            },
            {
                name: "ttt",
                label: "TTT kód",
                visibility: false
            },
            {
                name: "iso",
                label: "ISO kód",
                visibility: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ]
    }
}
